/* CARTER - imbuto della waiting list.

   Qui dentro non si parla con Google. Si pubblicano quattro eventi su
   Shopify con Shopify.analytics.publish(); a raccoglierli e a inoltrarli
   a GA4 ci pensa il pixel personalizzato GA4 Carter, che Shopify accende
   solo quando il visitatore ha dato il consenso alle statistiche.

   I quattro gradini:
     waitlist_cta_click   ha cliccato un pulsante che porta al form
     waitlist_form_start  ha messo il cursore nel campo email
     waitlist_submit      ha inviato il form
     waitlist_success     l'iscrizione e' andata a buon fine
*/
(function () {
  if (window.__carterTrack) return;
  window.__carterTrack = true;

  function manda(nome, dati) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(nome, dati || {});
      }
    } catch (e) {
      /* il tracciamento non deve mai rompere la pagina */
    }
  }

  function posizioneDi(el) {
    if (!el || !el.closest) return 'sconosciuta';
    if (el.closest('.carter-nav')) return 'menu';
    if (el.closest('.carter-hero')) return 'hero';
    if (el.closest('#carter-waitlist')) return 'sezione-waiting-list';
    if (el.closest('#carter-cta')) return 'cta-finale';
    if (el.closest('.carter-board')) return 'advisory-board';
    return 'altro';
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="#carter-waitlist"]') : null;
    if (!a) return;
    manda('waitlist_cta_click', {
      posizione: posizioneDi(a),
      etichetta: (a.textContent || '').trim().slice(0, 60)
    });
  }, true);

  function agganciaForm() {
    var moduli = document.querySelectorAll('form');

    Array.prototype.forEach.call(moduli, function (form) {
      var campo = form.querySelector('input[type="email"]');
      if (!campo) return;

      campo.addEventListener('focus', function () {
        if (form.dataset.carterIniziato) return;
        form.dataset.carterIniziato = '1';
        manda('waitlist_form_start', { posizione: posizioneDi(campo) });
      });

      form.addEventListener('submit', function () {
        var casella = form.querySelector('.form-consent input[type="checkbox"]');
        manda('waitlist_submit', {
          posizione: posizioneDi(form),
          consenso_marketing: casella ? !!casella.checked : false
        });
      });
    });

    var fatto = document.querySelector('.carter-done');
    if (fatto) manda('waitlist_success', { posizione: posizioneDi(fatto) });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agganciaForm);
  } else {
    agganciaForm();
  }
})();
